/* eslint-disable */
export default function getFileExt(type, fileName) {
    let ext = null;
    let extArray = ["pptx", "docx", "xlsx", "pdf", "zip", "png", "jpeg", "txt"];
    const MATRIALS = 1;

    if(+type === MATRIALS ){
        ext = fileName.split('.')[1].toLowerCase();

        if(!extArray.includes(ext)){
            ext = "document";
        }
    }else{
        switch (type) {
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                ext = "pptx";
                break;
            case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                ext = "docx";
                break;
            case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                ext = "xlsx";
                break;
            case "application/pdf":
                ext = "pdf";
                break;

            case "text/plain":
                ext = "txt";
                break;

            case "image/png":
                ext = "png";
                break;

            case "image/jpeg":
                ext = "jpeg";
                break;

            case "application/x-zip-compressed":
                ext = "zip";
                break;

            default:
                ext = "document";
                break;
        }
    }


    return ext;
}
